export default {
      id: "ic_phone-usage",
      viewBox: "0 0 15 15",
      url: "/" + "images/icons.3.109.2.svg#ic_phone-usage",
      toString: function () {
        return this.url;
      }
    }